import React from 'react'
import { Flex, Typography } from 'antd'
import { NavLink } from 'react-router-dom'
import './index.css'

const { Title, Text } = Typography

const Breadcrumb = ({title,pageName,breadcrumb}) => {
  return (
    <div className='breadcrumb-cs' style={{position:'relative'}}>
        <div className='container' >
            <Flex justify='center'>
                <Title level={1} className='title-size text-white m-0'>{title}</Title>
            </Flex>
            <Flex justify='center'>
                {
                    breadcrumb.map(
                        (breadCrumb,index)=> 
                            <Text strong key={'bread-crumb-'+index}>
                                <NavLink to={breadCrumb?.to} className='text-white'>{breadCrumb?.name}</NavLink>
                                <span className="mx-2 text-white">/</span>
                            </Text>
                        )
                }
                <Text strong  className="text-white">{pageName}</Text>
            </Flex>
        </div>
    </div>
  )
}

export {Breadcrumb}